/**
 * @generated SignedSource<<c522ded5792c0b6c5fc07bfc44cca60c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JoinConferenceButton_viewer$data = {
  readonly integrations: {
    readonly zoom: {
      readonly hasLocalRecordingTokenScope: boolean;
      readonly isConnected: boolean;
    } | null;
  };
  readonly lastUsedBrowserExtension: string | null;
  readonly uxSimplificationEnabled: boolean;
  readonly " $fragmentType": "JoinConferenceButton_viewer";
};
export type JoinConferenceButton_viewer$key = {
  readonly " $data"?: JoinConferenceButton_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"JoinConferenceButton_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JoinConferenceButton_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uxSimplificationEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastUsedBrowserExtension",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserIntegrations",
      "kind": "LinkedField",
      "name": "integrations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ZoomUserNode",
          "kind": "LinkedField",
          "name": "zoom",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isConnected",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasLocalRecordingTokenScope",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "d59abe05594189862ae3f3f567856346";

export default node;
